const ETopiks = Object.freeze([
    {
        id: 1,
        description: 'Survei Kepuasan Masyarakat'
    },
    {
        id: 2,
        description: 'Lain lain'
    },

])
export default ETopiks